import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from './auth-state.service';

export const permissionGuard = (requiredPermission: string | string[]): CanActivateFn => {
  return () => {
    const authState = inject(AuthStateService);
    const router = inject(Router);

    const perms = Array.isArray(requiredPermission) ? requiredPermission : [requiredPermission];
    if (!authState.hasAnyPermission(perms)) {
      return router.createUrlTree(['/forbidden']);
    }
    return true;
  };
};
